import * as Yup from "yup";

export const MASTER_DATA_TYPE = {
  BANK: "BANK",
  CAREER: "CAREER",
  REASON_FOR_LEAVING: "REASON_FOR_LEAVING",
  REASON_OF_LEAVING: "REASON_OF_LEAVING",
  ATTACHMENT_TYPE: "ATTACHMENT_TYPE",
  EMPLOYEE_TYPE: "EMPLOYEE_TYPE",
  COMPANY_REGULATION: "COMPANY_REGULATION",
  COURSE_CATEGORY: "COURSE_CATEGORY",
  COURCE_CATEGORY: "COURCE_CATEGORY",
  SKILL_TYPE: "SKILL_TYPE",
  SKILL_SET: "SKILL_SET",
  REASON_FOR_SEPARATION: "REASON_FOR_SEPARATION",
  REASON_OF_SEPARATION: "REASON_OF_SEPARATION",
};

export const initialValues = {
  commonTypeName: null,
  commonTypeNameEn: null,
  requireContractExpiryDate: false,
};

const MasterDataSchema = Yup.object().shape({
  commonTypeName: Yup.string().required("Please enter."),
  commonTypeNameEn: Yup.string().required("Please enter."),
});

export const MstReasonSchema = MasterDataSchema.shape({
  reasonForSSOId: Yup.string().required("Please enter."),
});

export default MasterDataSchema;
